<template>
  <button
    class="flex flex-col items-center transition-all duration-100 ease-out rounded-lg shadow-xs group focus:outline-none focus:shadow-outline"
    :class="{
      [sizeClasses.wrapper]: true,
      'opacity-50': disabled,
      'bg-blue-100': !isCompleted,
      'bg-orange-mia': isCompleted,
      'cursor-pointer hover:shadow-md hover:bg-blue-500': !disabled && !isCompleted,
    }"
    :disabled="disabled || isCompleted"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot name="icon">
      <component
        :is="iconComponent"
        v-if="isCompleted"
        class="text-green-600 fill-current"
        :class="sizeClasses.icon"
        src="check-circle"
      />
      <component
        :is="iconComponent"
        v-else
        class="text-gray-700 fill-current"
        :class="{
          [sizeClasses.icon]: true,
          'group-hover:text-white': !disabled,
        }"
        :src="icon"
      />
    </slot>

    <div
      :class="{
        [sizeClasses.label]: true,
        'text-white': isCompleted,
        'group-hover:text-white': !isCompleted && !disabled,
      }"
    >
      <highlight-html
        :queries="highlight.split(' ')"
        :html="content"
      />
    </div>
  </button>
</template>

<script>
import VsmIcon from '@/components/ui/VsmIcon.vue'
import HighlightHtml from '@/components/ui/HighlightHtml.vue'

export default {
  name: 'MiaCarEditActionCard',

  components: {
    'highlight-html': HighlightHtml,
    'mia-vsm-icon': VsmIcon
  },

  props: {
    content: {
      type: String,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    isCompleted: {
      type: Boolean,
      default: false
    },

    icon: {
      type: String,
      default: ''
    },

    iconType: {
      type: String,
      default: 'streamline'
    },

    highlight: {
      type: String,
      default: ''
    },

    size: {
      type: String,
      default: 'default'
    }
  },

  computed: {
    iconComponent() {
      switch (this.iconType) {
        // Vue Sidebar Menu
        case 'vsm':
          return 'mia-vsm-icon'

        default:
          return 'mia-streamline-icon'
      }
    },

    sizeClasses() {
      return {
        default: {
          wrapper: 'w-56 px-4 py-8',
          icon: 'w-12 h-12',
          label: 'mt-8 text-lg leading-6'
        },
        small: {
          wrapper: 'w-44 px-4 py-4',
          icon: 'w-8 h-8',
          label: 'mt-4 text-base leading-5'
        }
      }[this.size]
    }
  }
}
</script>
